module.exports = __webpack_public_path__ + "static/media/mtb.cc472c00.jpg";